import type { EditorName } from '@wix/thunderbolt-types'

export const getEditorNameFromEditorParams = (editorName?: string, isResponsive?: boolean): EditorName => {
	switch (editorName) {
		case 'onboarding':
			return 'Blocked'
		case 'studio':
		case 'siteHistory':
			return 'Studio'
		case 'editor_x':
			return 'EditorX'
		case 'externalPreview':
			if (isResponsive) {
				return 'Studio'
			}
			return 'Unknown'
		default:
			return 'Unknown'
	}
}
